/**
 * Replaces all dynamic route parameters in the given path with the provided values.
 *
 * @param path - The route path with dynamic segments (e.g., "/hco/:hcoId/hcps/:hcpId")
 * @param params - An object mapping param names to their replacement values (e.g., { hcoId: "123", hcpId: "456" })
 * @returns The formatted path with all parameters replaced
 */
export const replaceRouteParams = (
	path: string,
	params: Record<string, string>
): string => {
	return path.replace(/:([a-zA-Z0-9]+)/g, (_, paramName) => {
		if (!(paramName in params)) {
			return `:${paramName}`; // Keep it unchanged if no value is provided
		}
		return encodeURIComponent(params[paramName]);
	});
};
